<template lang="pug">

  div

    //-
      -
      - BUSCA
      -
      -

    v-dialog(v-model="visible" max-width="500px" :persistent="loadingUser || loadingRequest")

      .dialogHeader

        .dialogHeaderTitle
          | Gestor de planos

        .dialogHeaderClose
          .dialogCloseButton.mdi.mdi-close(@click="closeDialog")

      .dialogBody

        .dialogBodyContent

          //-
            -
            -
            - BUSCA
            -
            -
            -

          .searchInput
            input.searchField(v-model="userEmail" type="text" :disabled="loadingUser || loadingRequest" maxlength="64" placeholder="Digite um e-mail")
            .searchLoading(v-if="isEmailValid && (loadingUser /* || loadingRequest */)")
              v-progress-circular(indeterminate color="red" size="25")
            sos-button(v-else :disabled="loadingUser || loadingRequest || !isEmailValid" @buttonClick="searchUser()" color="purple" size="small" buttonIcon="mdi-magnify" buttonIconSize="20")

          //-
            -
            -
            - RESULTADO DA BUSCA
            -
            -
            -

          template(v-if="!loadingUser")

            .mt-7(v-if="!!foundUserProfile === true && foundUserProfile.status === 'FOUND'")

              //-
                - USUÁRIO ENCONTRADO
                -

              .foundUserTitle
                | Usuário encontrado:
              .foundUserWrapper(style="margin-bottom: 8px")
                .foundUser--image(:style="{ backgroundImage: 'url(' + foundUserProfile.image + ')'}")
                .foundUser--data
                  .data
                    b Nome:&nbsp;
                    span {{ foundUserProfile.name || 'Não encontrado' }}
                  .data
                    b E-mail:&nbsp;
                    span {{ foundUserProfile.email || 'Não encontrado' }}

              //-
                - CONSUMO
                -

              .mt-7.foundUserBlock(data-label="Consumo:")
                .foundUserWrapper
                  label.csLabel
                    span(v-html="'Número de usuários:'")
                  .csFields
                    .foundUserPlanTextContent
                      | {{ foundUserProfile.usersAmount || '0' }}

                .foundUserWrapper.mt-1
                  label.csLabel
                    span(v-html="'Todos os grupos:'")
                  .csFields
                    .foundUserPlanTextContent
                      | {{ foundUserProfile.groupsAmount || '0' }}

                .foundUserWrapper.mt-1
                  label.csLabel
                    span(v-html="'Grupos gerenciados:'")
                  .csFields
                    .foundUserPlanTextContent
                      | {{ foundUserProfile.managedGroupsAmount || '0' }}

              //-
                - PLANO ATIVO
                -

              .mt-7.foundUserBlock(data-label="Plano ativo:")
                .foundUserWrapper
                  sos-select(label="Nome do plano:" :items="userPlans" @sosSelectChanged="onSelectUserPlan" :default="userPlan.planId")

                template(v-if="userPlan.changed")
                    .foundUserNotes
                      b Nota:&nbsp;
                      | Você alterou o plano ou as capacidades! Salve as alterações ou refaça a busca.

                .foundUserWrapper.mt-1
                  label.csLabel
                    span(v-html="'Tipo de plano:'")
                  .csFields
                    .foundUserPlanTextContent(v-if="userPlan.planOrigin === 'DEFAULT'")
                      | Nenhum
                    .foundUserPlanTextContent(v-else-if="userPlan.planOrigin === 'CUSTOM'")
                      | Personalizado
                    .foundUserPlanTextContent(v-else-if="userPlan.planOrigin === 'VINDI'")
                      | Assinatura
                    .foundUserPlanTextContent(v-else-if="userPlan.planOrigin === 'COUPON'")
                      | Cupom
                    .foundUserPlanTextContent(v-else)
                      | Não identificado

                .foundUserWrapper.mt-1(v-if="userPlan.planOrigin === 'CUSTOM' || userPlan.planOrigin === 'VINDI' || userPlan.planOrigin === 'COUPON'")
                  label.csLabel
                    span Vencimento do plano:
                  .csFields
                    .foundUserPlanTextContent(v-if="userPlan.planOrigin === 'CUSTOM'")
                      | Ilimitado
                    .foundUserPlanTextContent(v-else-if="userPlan.planOrigin === 'VINDI'")
                      | {{ userPlan.vindi.planExpirationDate }}
                    .foundUserPlanTextContent(v-else-if="userPlan.planOrigin === 'COUPON'")
                      | {{ userPlan.coupon.planExpirationDate }}

              //-
                - LIMITES
                -

              .mt-7.foundUserBlock(data-label="Limites:")

                .foundUserWrapper.foundUserWrapper--twoColumns.foundUserWrapper--left
                  label.csLabel
                    span(v-html="'Escalas:'")
                  .csFields
                    input(v-model="userPlan.limiteEscalas" type="text" class="sosInput" maxlength="6" @input="handleScaleLimitInput")

                .foundUserWrapper.foundUserWrapper--twoColumns.foundUserWrapper--right
                  label.csLabel
                    span(v-html="'Usuários:'")
                  .csFields
                    input(v-model="userPlan.limiteUsuarios" type="text" class="sosInput" maxlength="6" @input="handleUserLimitInput" @blur="handleUserLimitInputBlur")

              //-
                - CAPACIDADES ESPECIAIS
                -

              .mt-7.foundUserBlock(data-label="Capacidades especiais:")

                .foundUserWrapper
                  sos-checkbox(id="gestor_de_planos" label="Gestor de planos" :checked="userPlan.planManager" @click="onSelectedUserPlanManagementCapability")

              //-
                - CAPACIDADES
                -

              .mt-7.foundUserBlock(data-label="Capacidades:")

                .foundUserWrapper
                  sos-checkbox(id="editor_de_usuarios" label="Editor de usuários" :checked="userPlan.editorUsuarios" @click="onSelectedUserEditingCapability")
                .foundUserWrapper
                  sos-checkbox(id="folha_de_pagamento" label="Folha de pagamento" :checked="userPlan.folhaPagamento" @click="onSelectUserPayrollCapability")
                .foundUserWrapper
                  sos-checkbox(id="relatorio_de_horas" label="Relatório de horas" :checked="userPlan.relatorioHoras" @click="onSelectUserTimeReportCapability")
                .foundUserWrapper
                  sos-checkbox(id="relatorio_de_escala" label="Relatório de escala" :checked="userPlan.relatorioEscala" @click="onSelectUserPdfScaleReportCapability")
                .foundUserWrapper
                  sos-checkbox(id="folha_de_ponto" label="Folha de ponto" :checked="userPlan.folhaDePonto" @click="onSelectUserTimesheetCapability")
                .foundUserWrapper
                  sos-checkbox(id="relacionar_escalas" label="Relacionar escalas" :checked="userPlan.relacionarEscalas" @click="onSelectUserAttachUserScalesCapability")

              //-
                - GRUPOS
                -

              .mt-7.foundUserBlock(v-if="userPlan.groups.length > 0" :data-label="userPlan.groups.length === 1 ? 'Papel no grupo:' : `Papel nos ${userPlan.groups.length} grupos:`")

                table(border="0" cellspacing="0" cellpadding="0").managerUsersTable.mt-4

                  thead.managerUserItem.managerUserItemHeader
                    th(width="50%") Grupo
                    th(width="50%") Papel

                  tbody
                    tr(v-for="(group, groupIndex) in userPlan.groups" :key="group.groupID" class="{ 'last': userPlan.groups.length === groupIndex + 1 }").managerUserItem
                      td(data-label="Grupo")
                        span(style="font-size: 14px; line-height: 1")
                          | {{ group.name }}
                      td(data-label="Papel")
                        sos-select(:label="''" :items="userRoles" @sosSelectChanged="(value) => onSelectUserRole(groupIndex, value)" :default="group.role")

                //-.foundUserWrapper
                  sos-select(:label="group.name" :items="userRoles" @sosSelectChanged="(value) => onSelectUserRole(groupIndex, value)" :default="group.role")

              //-
                - CUPOM EXPIRADO
                -

              .mt-7.foundUserBlock(v-if="!!userPlan.coupon === true && userPlan.planOrigin !== 'COUPON'" :data-label="!!userPlan.coupon.isActive === false ? 'Cupom expirado:' : 'Cupom ativo:'")

                .foundUserWrapper
                  label.csLabel
                    span {{ !!userPlan.coupon.isActive === false ? 'Plano expirado:' : 'Plano:' }}
                  .csFields
                    .mt-2(v-html="expiredCouponPlanByPlanCategory[userPlan.coupon.planCategory]")

                .foundUserWrapper.mt-1
                  label.csLabel
                    span {{ !!userPlan.coupon.isActive === false ? 'Expirou em:' : 'Vencimento:' }}
                  .csFields
                    .foundUserPlanTextContent
                      | {{ userPlan.coupon.planExpirationDate }}

                .foundUserNotes(v-if="!!userPlan.coupon.isActive === true")
                  b Nota:&nbsp;
                  | O cupom está ativo, mas o plano do cupom não está ativo por causa do plano personalizado.

              //-
                - ASSINATURA EXPIRADA
                -

              .mt-7.foundUserBlock(v-if="!!userPlan.vindi === true && userPlan.planOrigin !== 'VINDI'" :data-label="!!userPlan.vindi.isActive === false ? 'Assinatura expirada:' : 'Assinatura ativa:'")

                .foundUserWrapper
                  label.csLabel
                    span {{ !!userPlan.vindi.isActive === false ? 'Plano expirado:' : 'Plano:' }}
                  .csFields
                    div(v-html="userPlansExpired[userPlan.vindi.planId]")

                .foundUserWrapper.mt-1
                  label.csLabel
                    span {{ !!userPlan.vindi.isActive === false ? 'Expirou em:' : 'Vencimento:' }}
                  .csFields
                    .foundUserPlanTextContent
                      | {{ userPlan.vindi.planExpirationDate }}

                template(v-if="!!userPlan.vindi.isActive === true")
                  .foundUserNotes(v-if="userPlan.planOrigin === 'CUSTOM'")
                    b Nota:&nbsp;
                    | A assinatura está ativa, mas o plano assinado não está ativo por causa do plano personalizado.
                  .foundUserNotes(v-else-if="userPlan.planOrigin === 'COUPON'")
                    b Nota:&nbsp;
                    | A assinatura está ativa, mas o plano assinado não está ativo por causa do cupom ativo.

              //-
                - AÇÕES
                -

              .mt-7

                sos-button(
                  :disabled="loadingRequest || !userPlan.changed"
                  @buttonClick="salvar()"
                  buttonLabel="Salvar"
                  color="success"
                  size="medium"
                  buttonIcon="mdi-refresh"
                  buttonIconSize="20")

                sos-button(
                  v-if="userPlan.planOrigin === 'CUSTOM'"
                  :disabled="loadingRequest"
                  @buttonClick="desfazer()"
                  buttonLabel="Desfazer plano sob medida"
                  color="danger"
                  size="medium"
                  buttonIcon="mdi-broom"
                  buttonIconSize="20").ml-1

    //-
      -
      - Modal AVISO
      -
      -

    confirm-dialog(ref="cdConfirmModal" :title="cdParameters.title" :text="cdParameters.text" :buttonPosition="cdParameters.buttonPosition" :width="cdParameters.width" @close="cdAction")

</template>

<script>

  import { USER_ROLES, MANAGER_USER_ROLE, MEMBER_USER_ROLE, MASTER_USER_ROLE } from '@/constants'
  import { buildGroupObject } from '@/functions'

  import { isEmailValid, userLimitByPlanCategory, scaleLimitByPlanCategory, planCategoryByPlanId } from '@/utils.js'

  import { getUserByUserID, getGroupByID, apiGetUserIdByEmail } from '@/services/firebase'
  import { apiUpdateUserCustomPlan, apiUndoUserCustomPlan, apiGetUserCapabilities } from '@/services/users'

  // import { processUserProfile } from '@/mixins/utils.js'

  import SosButton from '@/components/SosButton'
  import SosSelect from '@/components/SosSelect'
  import SosCheckbox from '@/components/SosCheckbox'
  import ConfirmDialog from '@/modals/ConfirmDialog'

  import confirmDialogMixin from '@/mixins/cd.mixin.js'

  import userProfileBroken from '@/assets/images/user-profile-broken.png'
  // import groupplaceholder from '@/assets/images/groupplaceholder.png'

  //
  //
  //

  const userPlansExpired = {
    0: '<i aria-hidden="true" class="mdi mdi-shield-star-outline planItem--icon" style="color: rgba(0, 0, 0, 0.7);"></i><span class="planItem--text" style="color: rgba(0, 0, 0, 0.7);">Plano Gratuíto</span>',

    9: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--bronze"></i><span class="planItem--text planItem--bronze">Bronze</span><span class="planItem--time">Mensal</span>',
    13: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--bronze"></i><span class="planItem--text planItem--bronze">Bronze</span><span class="planItem--time">Anual</span>',

    10: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--silver"></i><span class="planItem--text planItem--silver">Silver</span><span class="planItem--time">Mensal</span>',
    14: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--silver"></i><span class="planItem--text planItem--silver">Silver</span><span class="planItem--time">Anual</span>',

    11: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--gold"></i><span class="planItem--text planItem--gold">Gold</span><span class="planItem--time">Mensal</span>',
    15: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--gold"></i><span class="planItem--text planItem--gold">Gold</span><span class="planItem--time">Anual</span>',

    12: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--platinum"></i><span class="planItem--text planItem--platinum">Platinum</span><span class="planItem--time">Mensal</span>',
    16: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--platinum"></i><span class="planItem--text planItem--platinum">Platinum</span><span class="planItem--time">Anual</span>',

    17: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--bronze"></i><span class="planItem--text planItem--bronze">Bronze</span><span class="planItem--time">30% de desconto</span><span class="planItem--time">Mensal</span>',
    21: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--bronze"></i><span class="planItem--text planItem--bronze">Bronze</span><span class="planItem--time">30% de desconto</span><span class="planItem--time">Anual</span>',

    18: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--silver"></i><span class="planItem--text planItem--silver">Silver</span><span class="planItem--time">30% de desconto</span><span class="planItem--time">Mensal</span>',
    22: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--silver"></i><span class="planItem--text planItem--silver">Silver</span><span class="planItem--time">30% de desconto</span><span class="planItem--time">Anual</span>',

    19: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--gold"></i><span class="planItem--text planItem--gold">Gold</span><span class="planItem--time">30% de desconto</span><span class="planItem--time">Mensal</span>',
    23: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--gold"></i><span class="planItem--text planItem--gold">Gold</span><span class="planItem--time">30% de desconto</span><span class="planItem--time">Anual</span>',

    20: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--platinum"></i><span class="planItem--text planItem--platinum">Platinum</span><span class="planItem--time">30% de desconto</span><span class="planItem--time">Mensal</span>',
    24: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--platinum"></i><span class="planItem--text planItem--platinum">Platinum</span><span class="planItem--time">30% de desconto</span><span class="planItem--time">Anual</span>',

    1: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--bronze"></i><span class="planItem--text planItem--bronze">Plano 2</span><span class="planItem--time">Mensal</span>',
    5: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--bronze"></i><span class="planItem--text planItem--bronze">Plano 2</span><span class="planItem--time">Anual</span>',

    2: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--silver"></i><span class="planItem--text planItem--silver">Plano 3</span><span class="planItem--time">Mensal</span>',
    6: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--silver"></i><span class="planItem--text planItem--silver">Plano 3</span><span class="planItem--time">Anual</span>',

    3: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--gold"></i><span class="planItem--text planItem--gold">Plano 4</span><span class="planItem--time">Mensal</span>',
    7: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--gold"></i><span class="planItem--text planItem--gold">Plano 4</span><span class="planItem--time">Anual</span>',

    4: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--platinum"></i><span class="planItem--text planItem--platinum">Plano 5</span><span class="planItem--time">Mensal</span>',
    8: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--platinum"></i><span class="planItem--text planItem--platinum">Plano 5</span><span class="planItem--time">Anual</span>',
  }

  const expiredCouponPlanByPlanCategory = {
    free: '<i aria-hidden="true" class="mdi mdi-shield-star-outline planItem--icon" style="color: rgba(0, 0, 0, 0.7);"></i><span class="planItem--text" style="color: rgba(0, 0, 0, 0.7);">Plano Gratuíto</span>',
    plano2: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--bronze"></i><span class="planItem--text planItem--bronze">Bronze</span>',
    plano3: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--silver"></i><span class="planItem--text planItem--silver">Silver</span>',
    plano4: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--gold"></i><span class="planItem--text planItem--gold">Gold</span>',
    plano5: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--platinum"></i><span class="planItem--text planItem--platinum">Platinum</span>',
  }

  const userPlans = [
    // PLANO PADRÃO
    { key: 'plan_0', value: '0', text: '<i aria-hidden="true" class="mdi mdi-shield-star-outline planItem--icon" style="color: rgba(0, 0, 0, 0.7);"></i><span class="planItem--text" style="color: rgba(0, 0, 0, 0.7);">Plano Gratuíto</span>' },

    //
    //
    //

    // BRONZE
    { key: 'plan_9', value: '9', text: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--bronze"></i><span class="planItem--text planItem--bronze">Bronze</span><span class="planItem--time">Mensal</span>' },
    { key: 'plan_13', value: '13', text: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--bronze"></i><span class="planItem--text planItem--bronze">Bronze</span><span class="planItem--time">Anual</span>' },
    // SILVER
    { key: 'plan_10', value: '10', text: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--silver"></i><span class="planItem--text planItem--silver">Silver</span><span class="planItem--time">Mensal</span>' },
    { key: 'plan_14', value: '14', text: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--silver"></i><span class="planItem--text planItem--silver">Silver</span><span class="planItem--time">Anual</span>' },
    // GOLD
    { key: 'plan_11', value: '11', text: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--gold"></i><span class="planItem--text planItem--gold">Gold</span><span class="planItem--time">Mensal</span>' },
    { key: 'plan_15', value: '15', text: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--gold"></i><span class="planItem--text planItem--gold">Gold</span><span class="planItem--time">Anual</span>' },
    // PLATINUM
    { key: 'plan_12', value: '12', text: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--platinum"></i><span class="planItem--text planItem--platinum">Platinum</span><span class="planItem--time">Mensal</span>' },
    { key: 'plan_16', value: '16', text: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--platinum"></i><span class="planItem--text planItem--platinum">Platinum</span><span class="planItem--time">Anual</span>' },

    //
    //
    //

    // BRONZE
    { key: 'plan_17', value: '17', text: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--bronze"></i><span class="planItem--text planItem--bronze">Bronze</span><span class="planItem--time">30% de desconto</span><span class="planItem--time">Mensal</span>', disabled: true },
    { key: 'plan_21', value: '21', text: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--bronze"></i><span class="planItem--text planItem--bronze">Bronze</span><span class="planItem--time">30% de desconto</span><span class="planItem--time">Anual</span>', disabled: true },
    // SILVER
    { key: 'plan_18', value: '18', text: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--silver"></i><span class="planItem--text planItem--silver">Silver</span><span class="planItem--time">30% de desconto</span><span class="planItem--time">Mensal</span>', disabled: true },
    { key: 'plan_22', value: '22', text: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--silver"></i><span class="planItem--text planItem--silver">Silver</span><span class="planItem--time">30% de desconto</span><span class="planItem--time">Anual</span>', disabled: true },
    // GOLD
    { key: 'plan_19', value: '19', text: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--gold"></i><span class="planItem--text planItem--gold">Gold</span><span class="planItem--time">30% de desconto</span><span class="planItem--time">Mensal</span>', disabled: true },
    { key: 'plan_23', value: '23', text: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--gold"></i><span class="planItem--text planItem--gold">Gold</span><span class="planItem--time">30% de desconto</span><span class="planItem--time">Anual</span>', disabled: true },
    // PLATINUM
    { key: 'plan_20', value: '20', text: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--platinum"></i><span class="planItem--text planItem--platinum">Platinum</span><span class="planItem--time">30% de desconto</span><span class="planItem--time">Mensal</span>', disabled: true },
    { key: 'plan_24', value: '24', text: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--platinum"></i><span class="planItem--text planItem--platinum">Platinum</span><span class="planItem--time">30% de desconto</span><span class="planItem--time">Anual</span>', disabled: true },

    //
    //
    //

    // BRONZE
    { key: 'plan_1', value: '1', text: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--bronze"></i><span class="planItem--text planItem--bronze">Plano 2</span><span class="planItem--time">Mensal</span>', disabled: true },
    { key: 'plan_5', value: '5', text: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--bronze"></i><span class="planItem--text planItem--bronze">Plano 2</span><span class="planItem--time">Anual</span>', disabled: true },
    // SILVER
    { key: 'plan_2', value: '2', text: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--silver"></i><span class="planItem--text planItem--silver">Plano 3</span><span class="planItem--time">Mensal</span>', disabled: true },
    { key: 'plan_6', value: '6', text: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--silver"></i><span class="planItem--text planItem--silver">Plano 3</span><span class="planItem--time">Anual</span>', disabled: true },
    // GOLD
    { key: 'plan_3', value: '3', text: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--gold"></i><span class="planItem--text planItem--gold">Plano 4</span><span class="planItem--time">Mensal</span>', disabled: true },
    { key: 'plan_7', value: '7', text: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--gold"></i><span class="planItem--text planItem--gold">Plano 4</span><span class="planItem--time">Anual</span>', disabled: true },
    // PLATINUM
    { key: 'plan_4', value: '4', text: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--platinum"></i><span class="planItem--text planItem--platinum">Plano 5</span><span class="planItem--time">Mensal</span>', disabled: true },
    { key: 'plan_8', value: '8', text: '<i aria-hidden="true" class="mdi mdi-shield-star planItem--icon planItem--platinum"></i><span class="planItem--text planItem--platinum">Plano 5</span><span class="planItem--time">Anual</span>', disabled: true },
  ]

  const defaultCapabilities = [
    { key: 'ENABLED', value: 'ENABLED', text: 'Habilitado' },
    { key: 'DISABLED', value: 'DISABLED', text: 'Desabilitado' },
  ]

  export default {
    name: 'DialogUserPlanManager',

    components: {
      'confirm-dialog': ConfirmDialog,
      'sos-button': SosButton,
      'sos-select': SosSelect,
      'sos-checkbox': SosCheckbox,
    },

    mixins: [
      confirmDialogMixin,
    ],

    /* props: {
      scaleTurns: {
        type: Array,
        default: () => [],
      },
    }, */

    data () {
      return {
        visible: false,

        loadingUser: false,
        loadingRequest: false,

        userEmail: '',

        foundUserProfile: {
          status: 'WAITING',
        },

        userPlansExpired,
        expiredCouponPlanByPlanCategory,
        userPlans,
        defaultCapabilities,

        userPlan: {
          changed: false,

          downloadedPlanId: '0',

          planId: '0',
          planCategory: 'free',
          planOrigin: 'DEFAULT',

          limiteEscalas: '1',
          limiteUsuarios: '15',

          editorUsuarios: false,
          folhaPagamento: false,
          relatorioEscala: false,
          relatorioHoras: false,
          folhaDePonto: false,
          relacionarEscalas: false,
          planManager: false,

          vindi: null,
          coupon: null,
        },
      }
    },

    computed: {
      isEmailValid: function () {
        return isEmailValid(this.userEmail)
      },

      newUserEmailLowerCase: function () {
        return String(this.userEmail).trim().toLowerCase()
      },

      userRoles: function () {
        return USER_ROLES.map(role => ({ key: role, value: role, text: role }))
      },
    },

    watch: {
      visible: {
        // the callback will be called immediately after the start of the observation
        handler (currentVisible, previousVisible) {
          if (currentVisible === false) this.clearFields()
        },
      },

      userEmail: {
        handler (current, previous)
        {
          if (String(current) !== String(previous) && this.foundUserProfile.status !== 'WAITING')
          {
            this.foundUserProfile = { status: 'WAITING' }

            // this.clearFields()
            // this.loadingUser = false
          }
        },
      },
    },

    /* mounted () {
    },

    beforeDestroy () {
    }, */

    methods: {
      /**
       *
       * ABRE O "DialogUserPlanManager" (UMA ESPÉCIE DE "OnMounted")
       *
       */

      open () {
        this.visible = true
        this.clearFields()
      },

      closeDialog () {
        if (this.loadingUser || this.loadingRequest) return false

        this.visible = false
      },

      /**
       *
       * LIMPEZA
       *
       */

      clearFields (onlyUserPlan = false) {
        if (!onlyUserPlan) {
          // this.visible = false
          this.loadingUser = false
          this.loadingRequest = false

          this.foundUserProfile = { status: 'WAITING' }

          this.userEmail = ''
        }

        this.userPlan = {
          changed: false,

          downloadedPlanId: '0',

          planId: '0',
          planCategory: 'free',
          planOrigin: 'DEFAULT',

          limiteEscalas: '1',
          limiteUsuarios: '15',

          editorUsuarios: false,
          folhaPagamento: false,
          relatorioEscala: false,
          relatorioHoras: false,
          folhaDePonto: false,
          relacionarEscalas: false,
          planManager: false,

          vindi: null,
          coupon: null,
        }
      },

      /**
       *
       * VERIFICA SE O E-MAIL INFORMADO JÁ ESTÁ CADASTRADO NO SISTEMA
       *
       * Possivel bug CASE SENSITIVE - 05/07/2022
       *
       */

      async searchUser ()
      {
        this.clearFields(true)

        //
        //
        //

        if (!this.isEmailValid)
        {
          this.foundUserProfile = { status: 'WAITING' }
          return false
        }

        //
        //
        //

        this.loadingUser = true

        const foundUserByEmail = await apiGetUserIdByEmail(this.newUserEmailLowerCase)

        //
        // ERRO AO BUSCAR USUÁRIO
        //

        if (foundUserByEmail.code === 0)
        {
          if ((foundUserByEmail?.data?.code || '') === 'auth/user-not-found')
          {
            // E-MAIL NÃO ENCONTRADO
            this.foundUserProfile = { status: 'NOT_FOUND' }
            this.showMessage('Falha!', 'Usuário não encontrado.')
          }
          else
          {
            // ERRO DESCONHECIDO AO LER USUÁRIO
            this.foundUserProfile = { status: 'ERROR' }
            this.showMessage('Falha!', 'Não foi possível buscar o e-mail. Tente novamente ou fale com o nosso suporte.')
          }

          this.loadingUser = false
        }

        //
        // USUÁRIO ENCONTRADO
        //

        else if (foundUserByEmail.code === 1)
        {
          const foundUserID = String(foundUserByEmail?.data || '')

          //
          // LER O PERFIL DO USUÁRIO
          //

          const uProfile = await getUserByUserID(foundUserID)

          if (!!uProfile === false)
          {
            this.foundUserProfile = { status: 'ERROR' }
            this.loadingUser = false

            return this.showMessage('Falha!', 'Não foi possível processar o perfil do usuário. Tente novamente ou fale com o nosso suporte.')
          }

          //
          // LER AS CAPACIDADES DO USUÁRIO
          //

          const response = await apiGetUserCapabilities({ userFirebaseID: foundUserID }, this.$store.state.app.userSession.userToken)

          if (response.httpCode !== 200)
          {
            this.loadingUser = false

            return this.showMessage('Falha!', 'Não foi possível processar as capacidades do usuário. Tente novamente ou fale com o nosso suporte.')
          }

          //
          // PROCESSAR APENAS OS GRUPOS (TIPO "public") QUE O USUÁRIO LOGADO (?) GERENCIA:
          //

          const userGroups = !!uProfile.grupos === true && typeof uProfile.grupos === 'object' && Array.isArray(uProfile.grupos) === false ? Object.entries(uProfile.grupos) : []

          // DEBUG
          // console.log(`::: [${foundUserID}] GRUPOS:`, userGroups.length)

          const allGroupsUsers = []

          const allGroups = userGroups.length === 0 ? [] : (await Promise.all(
            // PROCESSA APENAS OS GRUPOS ONDE O USUÁRIO É GESTOR
            // userGroups.filter(([_, group]) => !!group === true && !!group.admin === true).map(async ([groupID, group]) => {
            // PROCESSA APENAS OS GRUPOS ONDE O USUÁRIO É GESTOR

            userGroups.map(async ([groupID, group]) => {
              const storeGroup = this.$store.getters.getGroupById(groupID) || null

              let groupData = !!storeGroup === true ? storeGroup : null
              if (!!groupData === false) {
                // CARREGA DADOS DO GRUPO
                const loadedGroup = await getGroupByID(groupID)
                // É GRUPO OU CHAT?
                if (!!loadedGroup === false) return { groupID, error: 'NOT_LOADED' }
                if (!!loadedGroup.type === false) return { groupID, error: 'TYPE_NOT_FOUND' }
                if (loadedGroup.type !== 'public') return { groupID, error: 'CHAT' }
                // PROCESSA DADOS DO GRUPO
                groupData = buildGroupObject(groupID, loadedGroup)
              }

              const role = !!group.master === true ? MASTER_USER_ROLE : (
                !!group.admin === true ? MANAGER_USER_ROLE : MEMBER_USER_ROLE
              )

              // usersAmount apenas dos grupos que o usuário é GESTOR ou MASTER

              if (role !== MEMBER_USER_ROLE) {
                const groupUsers = !!groupData.groupUsers === true && typeof groupData.groupUsers === 'object' ? Object.keys(groupData.groupUsers) : []
                if (groupUsers.length > 0) groupUsers.forEach(userID => allGroupsUsers.push(userID))
              }

              // Output
              return { groupID, name: groupData.groupName || '[ERROR]', role }
            })
          )) // .filter(x => !!x === true) // Jesus: Remove chats

          // [24/01/25] const errorGroups = allGroups.filter(x => !!x.error === true)
          // [24/01/25] console.log('::: errorGroups:', errorGroups)

          const validGroups = allGroups.filter(x => !!x.error === false)
          const managedGroups = validGroups.filter(x => x.role !== MEMBER_USER_ROLE)
          const uniqueGroupsUsersAmount = [...new Set(allGroupsUsers)].length

          //
          //
          //

          this.foundUserProfile = {
            status: 'FOUND',
            userID: foundUserID,
            image: String(uProfile.img).indexOf('https://firebasestorage.googleapis.com/') !== -1 ? String(uProfile.img).trim() : userProfileBroken,
            name: String(uProfile.nome || '').trim(),
            email: String(uProfile.email || '').trim(),
            usersAmount: uniqueGroupsUsersAmount,
            groupsAmount: validGroups.length,
            managedGroupsAmount: managedGroups.length,
          }

          //
          //
          //

          this.userPlan = {
            ...this.userPlan,

            downloadedPlanId: String(response?.message?.planId || '0'),

            planId: String(response?.message?.planId || '0'),
            planCategory: String(response?.message?.planCategory || 'free'),
            planOrigin: String(response?.message?.planOrigin || 'DEFAULT'),

            limiteEscalas: String(response?.message?.userCapabilities?.limiteEscalas || '1'),
            limiteUsuarios: String(response?.message?.userCapabilities?.limiteUsuarios || '15'),

            editorUsuarios: Boolean(response?.message?.userCapabilities?.editorUsuarios || false),
            folhaPagamento: Boolean(response?.message?.userCapabilities?.folhaPagamento || false),
            relatorioEscala: Boolean(response?.message?.userCapabilities?.relatorioEscala || false),
            relatorioHoras: Boolean(response?.message?.userCapabilities?.relatorioHoras || false),
            folhaDePonto: Boolean(response?.message?.userCapabilities?.folhaDePonto || false),
            relacionarEscalas: Boolean(response?.message?.userCapabilities?.relacionarEscalas || false),
            planManager: Boolean(response?.message?.userCapabilities?.planManager || false), // FUNCIONALIDADES PARA SUPER ADMIN

            vindi: response?.message?.vindi || false,
            coupon: response?.message?.coupon || false,

            // Jesus: Evitar re-renders a cada grupo processado
            groups: validGroups.length > 0 ? validGroups : [],
          }

          //
          //
          //

          this.loadingUser = false
        }
      },

      handleScaleLimitInput () {
        this.userPlan.changed = true
        this.userPlan.limiteEscalas = String(this.userPlan.limiteEscalas.replace(/\D/g, '').replace(/^0+/, ''))

        if (Number(this.userPlan.limiteEscalas) < 1) this.userPlan.limiteEscalas = '1'
      },

      handleUserLimitInput () {
        this.userPlan.changed = true
        this.userPlan.limiteUsuarios = String(this.userPlan.limiteUsuarios.replace(/\D/g, '').replace(/^0+/, ''))

        if (Number(this.userPlan.limiteUsuarios) < 1) this.userPlan.limiteUsuarios = '1'
      },

      handleUserLimitInputBlur () {
        if (Number(this.userPlan.limiteUsuarios) < 15) this.userPlan.limiteUsuarios = '15'
      },

      onSelectUserPlan (selectedPlan)
      {
        const planId = String(selectedPlan)
        const planCategory = planCategoryByPlanId(planId)
        const limiteEscalas = scaleLimitByPlanCategory(planCategory)
        const limiteUsuarios = userLimitByPlanCategory(planCategory)
        const editorUsuarios = planCategory !== 'free' && planCategory !== 'plano2' // Silver ou superior
        const folhaPagamento = planCategory !== 'free' // Todos exceto free
        const relatorioEscala = planCategory !== 'free' // Todos exceto free
        const relatorioHoras = planCategory !== 'free' && planCategory !== 'plano2' // Silver ou superior
        const folhaDePonto = planCategory !== 'free' && planCategory !== 'plano2' // Silver ou superior
        const relacionarEscalas = planCategory !== 'free' && planCategory !== 'plano5' // Platinum
        const planManager = false

        this.userPlan = {
          ...this.userPlan,

          changed: true,

          planId,
          planCategory,
          limiteEscalas,
          limiteUsuarios,
          editorUsuarios,
          folhaPagamento,
          relatorioEscala,
          relatorioHoras,
          folhaDePonto,
          relacionarEscalas,
          planManager,
        }
      },

      onSelectedUserPlanManagementCapability ()
      {
        const planManager = !this.userPlan.planManager

        if (planManager)
        {
          this.showConfirmBox({
            title: 'Aviso!',
            text: 'O usuário terá acesso ao <b>gestor de planos</b> após salvar as alterações. <b>Deseja marcar essa opção?</b>',
            type: 'confirmPlanManager',
            data: '',
            isResponse: false,
            buttonPosition: 'right',
            width: 480,
            closeText: 'Voltar',
            continueText: 'Sim, marque a opção!',
          })
        }
        else
        {
          this.userPlan = {
            ...this.userPlan,
            changed: true,
            planManager: !this.userPlan.planManager,
          }
        }
      },

      onSelectedUserEditingCapability () {
        this.userPlan = {
          ...this.userPlan,
          changed: true,
          editorUsuarios: !this.userPlan.editorUsuarios,
        }
      },

      onSelectUserPayrollCapability () {
        this.userPlan = {
          ...this.userPlan,
          changed: true,
          folhaPagamento: !this.userPlan.folhaPagamento,
        }
      },

      onSelectUserTimeReportCapability () {
        this.userPlan = {
          ...this.userPlan,
          changed: true,
          relatorioHoras: !this.userPlan.relatorioHoras,
        }
      },

      onSelectUserPdfScaleReportCapability () {
        this.userPlan = {
          ...this.userPlan,
          changed: true,
          relatorioEscala: !this.userPlan.relatorioEscala,
        }
      },

      onSelectUserTimesheetCapability () {
        this.userPlan = {
          ...this.userPlan,
          changed: true,
          folhaDePonto: !this.userPlan.folhaDePonto,
        }
      },

      onSelectUserAttachUserScalesCapability () {
        this.userPlan = {
          ...this.userPlan,
          changed: true,
          relacionarEscalas: !this.userPlan.relacionarEscalas,
        }
      },

      onSelectUserRole (groupIndex, value)
      {
        this.userPlan = {
          ...this.userPlan,
          changed: true,
        }
        this.userPlan.groups[groupIndex].role = value
      },

      /**
       *
       * SALVAR ALTERAÇÕES
       *
       */

      async salvar ()
      {
        if (this.loadingUser || this.loadingRequest || this.foundUserProfile.status !== 'FOUND' || !this.userPlan.changed) return

        const requestPayload = {
          userFirebaseID: this.foundUserProfile.userID,
          planId: this.userPlan.planId,
          limiteEscalas: this.userPlan.limiteEscalas,
          limiteUsuarios: this.userPlan.limiteUsuarios,
          editorUsuarios: this.userPlan.editorUsuarios,
          folhaPagamento: this.userPlan.folhaPagamento,
          relatorioEscala: this.userPlan.relatorioEscala,
          relatorioHoras: this.userPlan.relatorioHoras,
          folhaDePonto: this.userPlan.folhaDePonto,
          relacionarEscalas: this.userPlan.relacionarEscalas,
          planManager: this.userPlan.planManager,
          groups: this.userPlan.groups,
        }

        this.loadingRequest = true

        // Executa
        const response = await apiUpdateUserCustomPlan(requestPayload, this.$store.state.app.userSession.userToken)

        // Mostra a resposta
        this.showMessage(response.title, (response.httpCode !== 200 || response.code !== 1) ? (
          'Não foi possível atualizar as capacidades do usuário!<br /><br /><b>Motivo</b>:<br />' + response.message
        ) : (
          response.message
        ))

        // Backup
        // this.showMessage(response.title, response.code === 'INVALID' ? response.message.join('\r\n') : response.message)

        // Clear component state, such as, stop loading behavior...
        this.clearFields()

        // Close window
        this.visible = false
      },

      /**
       *
       * DESFAZER PLANO PERSONALIZADO
       *
       */

      async desfazer ()
      {
        if (this.loadingUser || this.loadingRequest || this.foundUserProfile.status !== 'FOUND' || this.userPlan.planOrigin !== 'CUSTOM') return

        this.showConfirmBox({
          title: 'Aviso!',
          text: 'O plano personalizado será desfeito. Se houver algum cupom ou assinatura ativos, o usuário terá acesso as capacidades deles, caso contrário, retornará ao plano gratuíto.<br /><b>Deseja continuar?</b>',
          type: 'confirmUndo',
          data: '',
          isResponse: false,
          buttonPosition: 'right',
          width: 480,
          closeText: 'Voltar',
          continueText: 'Sim, desfaça o plano!',
        })
      },

      /**
       *
       * CONFIRM DIALOG OUTPUT/RESPONSE
       *
       */

      async cdAction (cdResponse)
      {
        if (cdResponse === false) return

        const type = cdResponse.cdType
        // const data = cdResponse.cdData

        if (type === 'confirmUndo')
        {
          // Sinaliza carregamento para a tela
          this.loadingRequest = true
          // Executa
          const response = await apiUndoUserCustomPlan({ userFirebaseID: this.foundUserProfile.userID }, this.$store.state.app.userSession.userToken)
          // Mostra a resposta
          this.showMessage(response.title, response.message)
          // Clear component state, such as, stop loading behavior...
          this.clearFields()
          // Close window
          this.visible = false
        }

        if (type === 'confirmPlanManager')
        {
          this.userPlan = {
            ...this.userPlan,
            changed: true,
            planManager: !this.userPlan.planManager,
          }
        }
      },
    },
  }

</script>

<style lang="scss">

  .planItem--icon,
  .planItem--text {
    display: inline-block;
    vertical-align: middle;
    line-height: 0;

    &.planItem--bronze { color: rgba(205, 127, 50, 1); }
    &.planItem--silver { color: rgba(192, 192, 192, 1); }
    &.planItem--gold { color: rgba(212, 175, 55, 1); }
    &.planItem--platinum { color: rgba(160, 178, 198, 1); }
  }

  .planItem--icon {
    font-size: 23px;
  }

  .planItem--text {
    margin-left: 5px;
    font-size: 16px;
    font-weight: 600;
  }

  .planItem--time {
    display: inline-block;
    vertical-align: middle;
    margin-left: 7px;
    padding: 3px 9px;
    border-radius: 7px;
    background-color: rgba(0, 0, 0, 0.1);

    color: #333333;
    font-size: 12px;
    font-weight: 500;
    line-height: 12px;
  }

</style>

<style scoped lang="scss">

  .managerUsersTable {
    width: 100%;

    span {
      display: inline-block;
      vertical-align: middle;

      word-break: break-all;
      line-height: 1; // Nota em 19/11/24: Email responsivo
    }
  }

  .managerUserItem {
    width: 100%;
    font-size: 0;
    line-height: 0;

    th {
      font-size: 15px;
      line-height: 30px;
    }

    td {
      font-size: 14px;
      line-height: 0;
    }

    th,
    td {
      position: relative;

      padding-left: 10px;
      padding-top: 10px;
      padding-bottom: 10px;
      padding-right: 10px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);

      color: #444444;
      text-align: left;

      &.managerUserContaCell {
        padding-left: 5px;
        padding-top: 5px;
        padding-bottom: 5px;
        padding-right: 5px;
        font-size: 0;
      }
      &.last {
        border-right: 0;
      }
    }

    &.managerUserItemHeader {
      th {
        padding-top: 0;
        padding-bottom: 4px;
        border-bottom: 3px solid rgba(0, 0, 0, 0.05);
      }
    }

    &.last {
      th,
      td {
        border-bottom: 0;
      }
    }
  }

  @media (max-width: 1280px) {
    .managerUsersTable {
      min-width: 1164px;
    }
  }

  @media (max-width: 768px) {
    .managerUsersTable {
      min-width: 0;

      thead {
        border: none;
        clip: rect(0 0 0 0);
        height: 1px;
        margin: -1px;
        overflow: hidden;
        padding: 0;
        position: absolute;
        width: 1px;
      }

      .managerUserItem {
        display: block;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
        border-left: 1px solid rgba(0, 0, 0, 0.1);
        border-right: 1px solid rgba(0, 0, 0, 0.1);
        border-bottom: 3px solid #ddd;
        border-radius: 10px;
        margin: 10px 0;

        td {
          display: block;
          text-align: right !important;
          padding: 10px 20px !important;

          &::before {
            content: attr(data-label);
            float: left;

            font-weight: bold;
            line-height: 1.5; // Nota em 19/11/24: Melhora exibição de dados abaixo de 768px (dispositivos móveis menores)
            text-transform: uppercase;
          }

          &:last-child {
            border-bottom: 0;
          }
        }

        &.last {
          th,
          td {
            border-bottom: 1px solid rgba(0, 0, 0, 0.05);
          }
        }
      }
    }
  }

  @media (max-width: 600px) {
    .managerUsersTable {
      .managerUserItem {
        td {
          text-align: left !important;

          &::before {
            float: none;
            display: block;
            width: 100%;
          }
        }
      }
    }
  }

  //
  //
  //

  .foundUserBlock {
    position: relative;

    padding: 12px 16px 16px 16px;
    border-radius: 7px;
    border: 1px solid rgba(0, 0, 0, 0.3);

    &::before {
      content: attr(data-label);

      position: absolute;
      top: -13px;
      left: 11px;

      padding: 0 5px;
      background-color: #FFFFFF;

      font-size: 20px;
      font-weight: 500;
      line-height: 25px;
    }
  }

  .foundUserNotes {
    display: inline-block;
    // max-width: 343px;
    margin-top: 9px;
    padding: 7px 14px;
    border-radius: 7px;
    background-color: lightgoldenrodyellow;

    font-size: 15px;
    line-height: 20px;
  }

  .foundUserPlanTextContent {
    display: inline-block;
    vertical-align: middle;

    color: slateblue;
    // color: seagreen;
    font-size: 15px;
    font-weight: 500;
    line-height: 15px;
  }

  .foundUserTitle {
    margin-bottom: 10px;

    font-size: 20px;
    font-weight: 500;
    line-height: 25px;
  }

  .foundUserWrapper {
    position: relative;

    display: inline-block;
    width: 100%;
    line-height: 0;

    &--twoColumns {
      width: 50%;
    }

    &--left {
      padding-right: 5px;
    }

    &--right {
      padding-left: 5px;
    }
  }

  .foundUser--image,
  .foundUser--data {
    display: inline-block;
    vertical-align: middle;
  }

  .foundUser--image {
    position: absolute;
    top: 0;
    width: 48px;
    height: 48px;
    border-radius: 7px;
    background-size: cover;
    background-color: #CCCCCC;
  }

  .foundUser--data {
    padding-left: 60px;

    word-break: break-all;

    .data {
      line-height: 24px;
    }

    &.foundUser--usage {
      padding-left: 0;
    }
  }

  .searchFieldIcon {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto 0 !important;
    left: 12px;
  }

  .searchField {
    width: 100%;
    // max-width: 320px;
    height: 100%;
    background-color: #ffffff;
    padding: 0 56px 0 12px;
    // padding: 0 56px 0 40px;
    // padding: 0 20px 0 40px;
    border-radius: 10px;
    border: 1px solid rgba(0, 0, 0, 0.25);
    outline: 0;
    // box-shadow: 1px 2px 2px -1px rgba(0, 0, 0, 0.25);
    font-size: 15px;
    &:disabled {
      background-color: #CCCCCC;
    }
  }

  .searchInput {
    position: relative;
    display: block;
    width: 100%;
    // max-width: 320px;
    height: 40px;

    .sosButton {
      position: absolute;
      top: 6px;
      right: 6px;
    }
  }

  .searchLoading {
    position: absolute;
    top: 7px;
    right: 7px;
    width: 25px;
    height: 25px;
  }

  @media (max-width: 600px) {
    .foundUser--data {
      width: 100%;
    }
  }

</style>
